export default __webpack_public_path__ + "img/bg_apply-947df423ec443ccb52548b9ba8fee542.png";